<template>
  <div class="dialog" v-if="showDialog">
    <transition name="dialog-fade">
      <div class="dialog-bg" v-if="showDialog" @click="clickCancel"></div>
    </transition>
    <transition name="dialog-show">
      <div class="dialog-box" v-if="showDialog">
        <h4 v-if="title" class="dialog-main dialog-main-title" >{{title}}</h4>
        <div v-if="content" class="dialog-main dialog-main-content" >{{content}}</div>
        <div class="dialog-button">
          <div class="dialog-confirm-button"
          @click="clickConfirm" v-if="!hideConfirm">{{okText || '好'}}</div>
           <div class="dialog-confirm-cancel"
          @click="clickCancel" v-if="!hideCancle">{{cancelText || '取消'}}</div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default{
  data() {
    return {};
  },
  props: ['showDialog', 'title', 'content', 'okText', 'cancelText', 'hideConfirm', 'hideCancle'],
  methods: {
    clickCancel() {
      this.$emit('cancel');
    },
    clickConfirm() {
      this.$emit('confirm');
    },
    confirmHide() {
      this.$emit('confirmhide');
    },
  },
};
</script>
<style lang="scss">
.dialog {
  position: fixed;
  top: 0; left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  &-bg {
    position: absolute;
    top: 0; left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.4);
  }
  &-box {
    width: 280px;
    position: absolute;
    top: 40%;
    left: 50%;
    -webkit-transform: translate3d(-50%,-50%,0);
    transform: translate3d(-50%,-50%,0);
    background-color: #fff;
    border-radius: 2px;
    line-height: 1.5;
    text-align: center;
  }
  &-main {
    text-align: center;
    padding: 21px 19px 20px;
    color:#24252d;
    &-content {
      padding-top: 0;
      color:#5B5E6A;
    }
    &-title {
      font-size: 16px;
    }
  }
  &-button {
    overflow: hidden;
    border-top: 1px solid #EEE;
    font-size: 16px;
    line-height: 44px;
    display: flex;
  }
  &-confirm {
    &-cancel {

      color: #3A82FF;
      flex:1;
      border-right: 1px solid #EEE;
      margin-right: -1px;
    }
    &-button {
      flex:1;
      color: #3A82FF;
      border-right: .5px solid #eaeaea;
    }
  }
  .dialog-show-enter-active, .dialog-fade-enter-active {
    transition: all .3s ease;
  }
  .dialog-show-leave-active, .dialog-fade-leave-active {
    transition: all .3s ease;
  }
  .dialog-show-enter, .dialog-show-leave-active {
    top: -35%;
  }
  .dialog-fade-enter, .dialog-fade-leave-active {
    opacity: 0;
  }
}
</style>

